import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.main`
  padding: 16px;
  padding-bottom: 60px;
  max-width: 1280px;
  width: 100%;
`;
